import { Route, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { getCookie } from '../../../utils/cookie-storage/cookie-storage';
import RoutesConstant from '../../../constants/routes';
import publicRoutes from '../../../constants/public-routes';

const PublicRoutes = () => {
  const navigate = useNavigate();
  const publicPathNames = [
    RoutesConstant.LOGIN,
  ];

  useEffect(() => {
    if (getCookie('auth-token')) {
      if (publicPathNames.includes(window.location.pathname)) {
        navigate(RoutesConstant.DASHBOARD);
      }
    }
  }, [navigate]);

  return (
    <>
      {publicRoutes.map((e, i) => {
        const Component = e?.component;
        return <Route key={i} path={e?.path} element={<Component />} />;
      })}
    </>
  );
};

export default PublicRoutes;
